import React, { useCallback, useEffect, useState } from "react";
import { api_v2 } from "../../NewIndex.api";
import "./Styles.css";
import AdminConfirmationModal from "../adminConfirmationModal";

const TETRulesLive = (props) => {
  const [lowLimit, setLowLimit] = useState("");
  const [upLimit, setUpLimit] = useState("");
  const [table, setTable] = useState([]);
  const [draftIsAvailable, setDraftIsAvailable] = useState(false);
  const fields = props.TETFields;
  const [flag, setFlag] = useState(false);
  const [aboveAndBelowText, setAboveAndBelowText] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showGenericMessage, setShowGenericMessage] = useState(false);
  const [genericMessage, setGenericMessage] = useState("");
  const setActiveTab = props.setActiveTab;

  function celsiusToFahrenheit(celsius) {
    return `Temperature in °F: ${Math.round((celsius * 9) / 5 + 32)}°F`;
  }
  useEffect(() => {
    const payload = {
      countryName: fields.country.value,
      userType: fields.userType.value,
      language: fields.language.value,
      productCode: fields.product.value,
    };
    api_v2.fetchTETRule(payload, (res) => {
      if (res.live !== null) {
        setDraftIsAvailable(res.draft === null ? false : true);
        const rulesObject = JSON.parse(res.live.rules);
        setFlag(true);

        if (Object.keys(rulesObject).length > 0) {
          setLowLimit(rulesObject.recMinRange);
          setUpLimit(rulesObject.recMaxRange);
          setAboveAndBelowText(rulesObject.aboveAndBelowMessage);
          setShowGenericMessage(
            rulesObject.showGenericMessage === "true" ? true : false
          );
          setGenericMessage(rulesObject.genericMessage);
          setTable(rulesObject.rule);
        }
      } else {
        setFlag(false);
      }
    });
  }, []);

  const handleCreateDraft = useCallback(() => {
    const payload = {
      countryName: fields.country.value,
      userType: fields.userType.value,
      language: fields.language.value,
      productCode: fields.product.value,
    };

    api_v2.makeDraftTETRule(payload, (res) => {
      if (res.status === 201) {
        setDraftIsAvailable(true);
        props.showNotification(
          "Success",
          "Draft Created Successfully",
          "success"
        );
        setActiveTab("draftTETData");
      } else {
        props.showNotification(
          "Error",
          "Something went wrong, Please try again later",
          "error"
        );
      }
    });
    setShowModal(false);
  }, [fields]);

  const handleCancel = () => {
    setShowModal(false);
  };
  const handleCreateDraftRule = () => {
    setShowModal(true);
  };
  return (
    <div>
      {flag ? (
        <div>
          <AdminConfirmationModal
            isModalOpen={showModal}
            toggleYes={handleCreateDraft}
            toggleCancel={handleCancel}
            bodyContent={"Are you sure you want to create a draft?"}
          />
          <div style={{ marginTop: "15px", marginLeft: "8px" }}>
            <div className="row">
              <label className="custom-control custom-checkbox mr-0">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  checked={showGenericMessage}
                  disabled
                />
                <span
                  id="enableTETProduct"
                  className="custom-control-indicator"
                />
                <span
                  className="custom-control-description"
                  style={{ marginLeft: "3px" }}
                >
                  Show Generic Message
                </span>
              </label>
            </div>
            {showGenericMessage && (
              <div className="row">
                <div>
                  <b>Generic Message*:</b>
                </div>
                <div style={{ width: "100%" }}>
                  <textarea
                    style={{ width: "100%", height: "100%" }}
                    value={genericMessage}
                    readOnly
                  />
                </div>
              </div>
            )}
          </div>
          {!showGenericMessage && (
            <div>
              <div
                className="col-md-4 p-0"
                style={{
                  marginBottom: "20px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Recommended range From:
                <input
                  type="text"
                  className="form-control"
                  style={{ width: "50px" }}
                  value={lowLimit}
                  readOnly
                />
                °C To:
                <input
                  type="text"
                  className="form-control"
                  style={{ width: "50px" }}
                  value={upLimit}
                  readOnly
                />
                °C
              </div>
              {/* Table section */}
              <div className="row" style={{ overflowX: "auto" }}>
                <div
                  className="new-col"
                  style={{ width: "100%", marginLeft: "10px" }}
                >
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th style={{ width: "320px" }} colSpan="2">
                          Temperature Range in °C
                        </th>
                        <th style={{ width: "340px" }} colSpan="2">
                          Duration in Hours
                        </th>
                        <th style={{ minWidth: "424.82px", width: "426px" }}>
                          Message
                        </th>
                        <th>Color</th>
                      </tr>
                    </thead>
                    <tbody id="tableBody">
                      {table.map((row, index) => (
                        <tr key={index}>
                          <td style={{ width: "150px" }}>
                            <div>
                              <select disabled>
                                <option selected>{row.tempMinRange}</option>
                              </select>
                              <input type="text" value={row.tempMin || ""} />
                              °C
                            </div>
                            <div
                              style={{ marginTop: "5px", fontWeight: "bold" }}
                            >
                              {row.tempMin
                                ? celsiusToFahrenheit(row.tempMin)
                                : ""}
                            </div>
                          </td>
                          <td style={{ width: "150px" }}>
                            <div>
                              <select disabled>
                                <option selected>{row.tempMaxRange}</option>
                              </select>
                              <input
                                type="text"
                                value={row.tempMax || ""}
                                readOnly
                              />
                              °C
                            </div>
                            <div
                              style={{ marginTop: "5px", fontWeight: "bold" }}
                            >
                              {row.tempMax
                                ? celsiusToFahrenheit(row.tempMax)
                                : ""}
                            </div>
                          </td>
                          <td style={{ width: "160px" }}>
                            <div>
                              <select disabled>
                                <option selected>{row.durationMinRange}</option>
                              </select>
                              <input
                                type="text"
                                value={row.durationMin || ""}
                                readOnly
                              />
                              Hrs
                            </div>
                          </td>
                          <td style={{ width: "160px" }}>
                            <div>
                              <select disabled>
                                <option selected>{row.durationMaxRange}</option>
                              </select>
                              <input
                                type="text"
                                value={row.durationMax || ""}
                                readOnly
                              />
                              Hrs
                            </div>
                          </td>

                          <td>{row.message || ""}</td>
                          <td style={{ width: "100px" }}>
                            <div
                              style={{
                                width: "20px",
                                height: "20px",
                                backgroundColor: row.color,
                                borderRadius: "4px",
                                display: "inline-block",
                              }}
                            ></div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <br />
              <div className="row">
                <div style={{ width: "100%", marginLeft: "10px" }}>
                  <div>
                    <b>Above and Below text:</b>
                  </div>
                  <textarea
                    style={{ width: "100%", height: "100%" }}
                    value={aboveAndBelowText}
                    readOnly
                  />
                </div>
              </div>
            </div>
          )}
          <br />
          <div className="row">
            <div>
              <button
                style={{ marginLeft: "9px" }}
                className="btn btn-lg btn-info btn-rounded save_button"
                onClick={handleCreateDraftRule}
                disabled={draftIsAvailable}
              >
                Create Draft
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div>No TET Live table present</div>
      )}
    </div>
  );
};

export default TETRulesLive;



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/TET/V2TETRulesLive.js